/*! angular-csv-import - v0.0.13 - 2014-09-18
 * Copyright (c) 2014 ; Licensed  */
/*! angular-csv-import - v0.0.11 - 2014-07-12
 * Copyright (c) 2014 ; Licensed  */
/*! angular-csv-import - v0.0.6 - 2014-07-11
 * Copyright (c) 2014 ; Licensed  */
/*! angular-csv-import - v0.0.4 - 2014-07-10
 * Copyright (c) 2014 ; Licensed  */
'use strict';

var csvImport = angular.module('ngCsvImport', []);

csvImport.directive('ngCsvImport', function() {
    return {
        restrict: 'E',
        transclude: true,
        replace: true,
        scope:{
            content:'=',
            header: '=',
            headerVisible: '=',
            separator: '@',
            result: '=',
            modal: '=',
            error: '='
        },
        template: '<div><div ng-show="header && headerVisible"><div class="label">Header</div><input type="checkbox" ng-model="header"></div>'+
            //'<div><input class="btn cta gray" type="file"/></div></div>',
            //    '<div><a href="" ng-click="show = !show">Import</a><input ng-if="show === true" type="file" class="btn btn-link btn-sm"/></div></div>',
            //'<div class="fileSelect"><div class="upload" style="padding: 0; height: auto; font-size: 100%;"><span style="padding: 0;">Import</span><input type="file" class="input" title="Import Users" onclick="this.value = null" accept=".csv"/></div></div>',
            '<div class="fileSelect"><div class="upload" ng-class="{\'modal-import-button\': modal === true}"><span ng-transclude></span><input type="file" class="input" title="Import" onclick="this.value = null" accept=".csv"/></div></div>',
        //'</div',
        link: function(scope, element) {
            element.on('keyup', function(e){
                if ( scope.content !== null ) {
                    var content = {
                        csv: scope.content,
                        header: scope.header,
                        separator: e.target.value
                    };
                    scope.result = csvToJSON(content);
                    scope.$apply();
                }
            });

            element.on('change', function(onChangeEvent) {
                var fileName = onChangeEvent.target.files[0].name;
                if(fileName.length > 4 && fileName.substring(fileName.length - 4) !== '.csv'){
                    //Error, should only allow csv import
                    scope.error = 'Please upload a valid CSV file.';
                    return;
                }
                var reader = new FileReader();
                reader.onload = function(onLoadEvent) {
                    scope.$apply(function() {
                        var content = {
                            csv: onLoadEvent.target.result,
                            header: scope.header,
                            separator: scope.separator
                        };

                        scope.content = content.csv;
                        scope.result = csvToJSON(content);
                    });
                };
                if ( (onChangeEvent.target.type === 'file') && (onChangeEvent.target.files !== null || onChangeEvent.srcElement.files !== null) )  {
                    reader.readAsText((onChangeEvent.srcElement || onChangeEvent.target).files[0]);
                } else {
                    if ( scope.content !== null ) {
                        var content = {
                            csv: scope.content,
                            header: !scope.header,
                            separator: scope.separator
                        };
                        scope.result = csvToJSON(content);
                    }
                }
            });

            var csvToJSON = function(content) {
                var lines=content.csv.split('\n');
                var result = [];
                var start = 0;
                var columnCount = lines[0].split(content.separator).length;

                var headers = [];
                if (content.header) {
                    headers=lines[0].split(content.separator);
                    start = 1;
                    var propertyNames = [];
                    for (var j=0; j<headers.length; j++) {
                        propertyNames.push(headers[j]);
                    }
                    result.push(propertyNames);
                }

                for (var i=start; i<lines.length; i++) {
                    var obj = {};
                    var currentline=lines[i].split(content.separator);
                    if ( currentline.length === columnCount ) {
                        if (content.header) {
                            for (var m=0; m<headers.length; m++) {
                                obj[headers[m]] = currentline[m];
                            }
                        } else {
                            for (var k=0; k<currentline.length; k++) {
                                obj[k] = currentline[k];
                            }
                        }
                        result.push(obj);
                    }
                }

                return JSON.stringify(result).replace(/\\r/g, '');
            };
        }
    };
});
